import { useEffect, useState } from 'react';
import { requestRemoteState } from '../components/Controls/remoteStateApi';

// Full-screen presentations expose webpage URLs, which cannot be used as image previews.
export default function useDeckScreenshot(deviceId, deck, mixTriggeredAt = null) {
  const contentKey = `${deck?.type || ''}:${deck?.contentId || deck?.overlayId || deck?.creativeId || deck?.videoId || ''}`;
  const needsScreenshot = deck?.type === 'full_overlay_ad';
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!deviceId || !needsScreenshot) return undefined;
    let cancelled = false;
    setPreview(null);
    // A deck update during the mix must retain the deadline of the Mix Now trigger.
    const elapsedSinceMix = mixTriggeredAt == null ? Infinity : Date.now() - mixTriggeredAt;
    const delay = elapsedSinceMix < 2000 ? Math.max(0, 2000 - elapsedSinceMix) : 2000;
    const timer = setTimeout(async () => {
      try {
        const state = await requestRemoteState({ deviceId, includeScreenshot: true });
        if (!cancelled) {
          setPreview({ deviceId, contentKey, dataUrl: state?.screenshot?.dataUrl || null });
        }
      } catch (error) {
        if (!cancelled) setPreview({ deviceId, contentKey, dataUrl: null });
      }
    }, delay);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, [deviceId, contentKey, needsScreenshot, mixTriggeredAt]);

  if (!needsScreenshot) return null;
  const currentPreview = preview?.deviceId === deviceId && preview?.contentKey === contentKey ? preview : null;
  return {
    dataUrl: currentPreview?.dataUrl || null,
    message: currentPreview ? 'Screen preview unavailable.' : 'Waiting for screen preview…',
  };
}
